class SonikitTimer extends HTMLElement {
  #shadow

  constructor() {
    super();
    this.#shadow = this.attachShadow({ mode: 'closed' });
  }

  set patch(data) {
    this._patch = data;

    this.endTime = new Date(this._patch.release_date); // ISO or timestamp
    this.interval = null;
    this.updateTime = this.updateTime.bind(this);

    this.render();

    this.updateTime();
    this.interval = setInterval(this.updateTime, 1000);
  }

  formatNumber(number) {
    return number < 10 ? `0${parseInt(number)}` : parseInt(number);
  }

  updateTime() {
    const now = new Date();
    const remaining = Math.max(0, this.endTime - now);
    const seconds = Math.floor(remaining / 1000) % 60;
    const minutes = Math.floor(remaining / 60000) % 60;
    const hours = Math.floor(remaining / 3600000) % 24;
    const days = Math.ceil(remaining / (1000 * 60 * 60 * 24));
    
    this._days.textContent = this.formatNumber(days);
    this._hours.textContent = this.formatNumber(hours);
    this._minutes.textContent = this.formatNumber(minutes);
    this._seconds.textContent = this.formatNumber(seconds);

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.shadowRoot.querySelector('.timer').textContent = 'Expired';
      this.dispatchEvent(new CustomEvent('expired'));
    }
  }

  async render() {
    const template = document.createElement('template');
    template.innerHTML = `
      <style>
        .wrapper {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 6px;
          background-color: white;
          text-align: center;
          padding: 10px;
          box-sizing: border-box;
          width: 100%;
          border-radius: 20px;
          pointer-events: none;
          user-select: none;
          box-shadow: 0 0 0 1px #8898aa1a, 0 15px 35px rgba(0,0,0,0.025), 0 5px 15px rgba(0,0,0,0.025);
        }
        .label {
          font-size: 0.9em;
        }
        .countdown {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          gap: 10px;
        }
        .countdown__digit {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .countdown__number {
          font-size: 2.2em;
        }
        .countdown__spacer {
          font-size: 2.2em;
        }
        .countdown__label {
          font-size: 0.7em;
        }
      </style>
      <div class="wrapper">
        <div class="label">Available ${this.endTime.toLocaleDateString('en-US', {year: 'numeric',month: 'long',day: '2-digit'})}</div>
        <div class="countdown">
          <div class="countdown__digit">
            <div class="countdown__number" data-role="days">--</div> 
            <div class="countdown__label">DAYS</div>
          </div>
          <div class="countdown__spacer">:</div>
          <div class="countdown__digit">
            <div class="countdown__number" data-role="hours">--</div> 
            <div class="countdown__label">HOURS</div>
          </div>
          <div class="countdown__spacer">:</div>
          <div class="countdown__digit">
            <div class="countdown__number" data-role="minutes">--</div> 
            <div class="countdown__label">MINS</div>
          </div>
          <div class="countdown__spacer">:</div>
          <div class="countdown__digit">
            <div class="countdown__number" data-role="seconds">--</div> 
            <div class="countdown__label">SECS</div>
          </div>
        </div>
      </div>
    `

    this.#shadow.appendChild(template.content.cloneNode(true));
    this._days = this.#shadow.querySelector('.countdown__number[data-role="days"]');
    this._hours = this.#shadow.querySelector('.countdown__number[data-role="hours"]');
    this._minutes = this.#shadow.querySelector('.countdown__number[data-role="minutes"]');
    this._seconds = this.#shadow.querySelector('.countdown__number[data-role="seconds"]');
  }
}

customElements.define('sonikit-timer', SonikitTimer);